import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
        padding: '40px 20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: 800,
          margin: '0 auto',
          backgroundColor: 'white',
          borderRadius: 16,
          padding: 40,
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        }}
      >
        <h1
          style={{
            fontSize: 32,
            fontWeight: 600,
            color: '#1e293b',
            marginBottom: 8,
          }}
        >
          Privacy Policy
        </h1>
        <p style={{ fontSize: 14, color: '#64748b', marginBottom: 32 }}>
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            1. Introduction
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569' }}>
            Berg Regions ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains our minimal data practices for our unified authentication service. We believe in simplicity and transparency: we only use your email address for authentication purposes.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            2. Information We Collect
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginBottom: 12 }}>
            We collect only the essential information needed for authentication:
          </p>
          <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', paddingLeft: 20 }}>
            <li><strong>Email address</strong> - Used solely for authentication purposes</li>
            <li><strong>Password</strong> (optional) - If you choose email/password authentication instead of social login</li>
          </ul>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginTop: 12 }}>
            <strong>Important:</strong> We do not store any profile data, personal information, or communication preferences. Authentication is handled through AWS Cognito, and we do not maintain a separate database of user information.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            3. How We Use Your Information
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginBottom: 12 }}>
            We use your email address for one purpose only:
          </p>
          <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', paddingLeft: 20 }}>
            <li><strong>Authentication</strong> - To verify your identity and provide passwordless login across Berg Regions applications</li>
          </ul>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginTop: 12 }}>
            We do NOT use your email address for:
          </p>
          <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', paddingLeft: 20 }}>
            <li>Marketing or promotional communications</li>
            <li>Newsletters or updates</li>
            <li>Sharing with third parties</li>
            <li>Analytics or tracking</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            4. Facebook and Google Sign-In
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginBottom: 12 }}>
            When you use Facebook or Google sign-in, we use these services <strong>only to verify your email address</strong>. We do not:
          </p>
          <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', paddingLeft: 20 }}>
            <li>Access your social media profile information</li>
            <li>Read your posts or friends list</li>
            <li>Store any data from your Facebook or Google account</li>
            <li>Post on your behalf</li>
          </ul>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginTop: 12 }}>
            The sole purpose of social login integration is to simplify the authentication process by verifying your email address through a trusted provider.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            5. Data Storage and Retention
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569' }}>
            We do not store user data beyond what is necessary for authentication. Your authentication credentials are securely managed by AWS Cognito. We do not maintain logs, analytics, or any form of user tracking.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            6. Information Sharing
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569' }}>
            We do not sell, rent, or share your personal information with anyone. Your email address is used exclusively for authentication and is not shared with third parties, advertisers, or marketing services.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            7. Data Security
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569' }}>
            Your authentication data is protected using industry-standard security measures provided by AWS Cognito, including encryption and secure transmission protocols. While we maintain minimal data, what we do process is handled with the highest security standards.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            8. Your Rights
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginBottom: 12 }}>
            You have the right to:
          </p>
          <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', paddingLeft: 20 }}>
            <li>Request deletion of your account and authentication data</li>
            <li>Access information about what data we hold (which is only your email address)</li>
            <li>Stop using our service at any time</li>
          </ul>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginTop: 12 }}>
            To exercise these rights, please visit our <a href="/data-deletion" style={{ color: '#3b82f6', textDecoration: 'none' }}>User Data Deletion</a> page or contact us at support@bergregions.pl.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            9. Third-Party Services
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569' }}>
            Our service uses AWS Cognito for authentication infrastructure and integrates with Facebook Login and Google Sign-In for email verification. When you use social login, you are subject to their respective privacy policies. We recommend reviewing:
          </p>
          <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', paddingLeft: 20 }}>
            <li>Facebook Privacy Policy</li>
            <li>Google Privacy Policy</li>
            <li>AWS Privacy Notice</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            10. Changes to This Policy
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569' }}>
            We may update this Privacy Policy from time to time. Changes will be reflected by updating the "Last updated" date at the top of this policy. Given our minimal data practices, substantial changes are unlikely.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            11. Contact Us
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569' }}>
            If you have any questions about this Privacy Policy or our practices, please contact us at{' '}
            <a
              href="mailto:support@bergregions.pl"
              style={{ color: '#3b82f6', textDecoration: 'none' }}
            >
              support@bergregions.pl
            </a>
          </p>
        </section>

        <div style={{ marginTop: 40, paddingTop: 24, borderTop: '1px solid #e5e7eb' }}>
          <a
            href="/login"
            style={{
              display: 'inline-block',
              padding: '10px 20px',
              backgroundColor: '#3b82f6',
              color: 'white',
              borderRadius: 8,
              textDecoration: 'none',
              fontSize: 14,
              fontWeight: 500,
              transition: 'background-color 0.2s',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#2563eb')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#3b82f6')}
          >
            Back to Login
          </a>
        </div>
      </div>
    </div>
  );
}
